import LoginWhatsAppPage from "@/pages/Auth/LoginWhatsAppPage";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/api/api";
import moment from "moment";
import dayjs from "dayjs";

export default function PhoneNumberLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const fromOnboarding = (location.state as any)?.fromOnboarding || false;
  const onboardingData = (location.state as any)?.onboardingData || null;

  const handleAfterLogin = async (phone: string | null) => {
    console.log("PhoneNumberLogin - handleAfterLogin called with phone:", phone);
    console.log("PhoneNumberLogin - location.state:", location.state);

    // Check if user came from pricing page
    const fromPricing = (location.state as any)?.fromPricing || false;
    const packageInfo = (location.state as any)?.packageInfo || null;
    const onboardingData = (location.state as any)?.onboardingData || null;

    console.log("PhoneNumberLogin - fromPricing:", fromPricing);
    console.log("PhoneNumberLogin - packageInfo:", packageInfo);
    console.log("PhoneNumberLogin - onboardingData:", onboardingData);

    // If user has onboarding data (from upcoming event flow), create the event first
    if (onboardingData) {
      console.log("PhoneNumberLogin - Creating event with onboarding data");
      try {
        const now = new Date();
        const eventValues: any = {
          orientation: "v",
          name: "My upcoming event", // Default event name instead of step5
          host_name: "host", // Default host name since we removed userName step
          host: "host", // Add host field as API expects both
          event_created_date: moment(now).format("Y-MM-DD"),
          address: {
            address: onboardingData?.step6?.address?.address || "", // Updated from step7 to step6
            lat: onboardingData?.step6?.address?.lat || 0, // Updated from step7 to step6
            lng: onboardingData?.step6?.address?.lng || 0, // Updated from step7 to step6
          },
          text_style: {
            font_family: "Inter", // API expects font_family not fontFamily
            font_size: "16px", // API expects font_size not fontSize
            font_style: {
              textBold: false,
              textItalic: false,
              textUnderline: false,
            },
            color: "#000000",
            text_align: "center", // API expects text_align not textAlign
          },
          text_position: "flex-start",
          start_datetime: onboardingData?.step5?.start_datetime ?
            dayjs(onboardingData.step5.start_datetime).format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ") :
            dayjs(now).format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ"), // Use correct format
          venue: onboardingData?.step6?.address?.address || "", // Updated from step7 to step6
          language: "en",
          invitation_show_qr_code: (onboardingData as any)?.step3a?.needsQr ? 1 : 0, // Convert to number as API expects
          qr_wallet: false,
          simplified: true, // API expects this field
          is_open_event: false, // API expects this field
          ugc_enabled: false, // API expects this field
          qr_code_design_id: null, // API expects this field
        };

        console.log("PhoneNumberLogin - Event values to create:", eventValues);

        try {
          const result = await api.events.createEventOnboarding(eventValues);
          console.log("PhoneNumberLogin - Event created successfully:", result);
        } catch (error) {
          console.error("PhoneNumberLogin - Error creating event:", error);
        }

        // If user came from pricing page, redirect to credits with package selected
        if (fromPricing && packageInfo) {
          console.log("PhoneNumberLogin - Redirecting to credits page");
          navigate("/credits", {
            state: {
              selectedPackage: packageInfo.package,
              packageKey: packageInfo.packageKey,
              guestCount: packageInfo.guestCount,
              fromPricing: true
            },
            replace: true,
          });
          return;
        }

        // If user came from onboarding (not pricing), go to pricing loading screen
        const fromOnboarding = (location.state as any)?.fromOnboarding || false;
        if (fromOnboarding) {
          console.log("PhoneNumberLogin - Redirecting to pricing loading screen");
          const guestsRaw: any = onboardingData?.step4?.guestNumber;
          const guestsParsed = typeof guestsRaw === 'string' ? parseInt(guestsRaw, 10) : Number(guestsRaw);
          const guests = Number.isFinite(guestsParsed) && guestsParsed > 0 ? guestsParsed : 1;

          const rsvpSource =
            (onboardingData as any)?.step4?.attendance ??
            (onboardingData as any)?.step2?.attendance ??
            (onboardingData as any)?.step1?.hasEvent ??
            (onboardingData as any)?.step0?.hasEvent ??
            false;
          const quotePayload = {
            guests,
            needEntranceManagement: (onboardingData as any)?.step3?.entrance ? "yes" : "no",
            needFreeReplacement: (onboardingData as any)?.step1?.autoRefund ? "yes" : "no",
            needRSVP: rsvpSource ? "yes" : "no",
            needQRCode: (onboardingData as any)?.step3a?.needsQr ? "yes" : "no",
          };


          // All users coming from onboarding have upcoming events (we just created one)
          // So they should all go to the loading screen first
          navigate("/pricing-loading", {
            state: {
              name: "", // Empty name since we removed userName step
              phone: phone || "",
              quotePayload,
            },
            replace: true,
          });
          return;
        }
      } catch (e) {
        console.error("PhoneNumberLogin - Error in onboarding flow:", e);
        navigate("/my-invites");
        return;
      }
    }

    // If user came from pricing page but has no onboarding data (quick pricing flow), 
    // redirect to credits with package selected
    if (fromPricing && packageInfo) {
      console.log("PhoneNumberLogin - Redirecting to credits page (quick pricing flow)");
      navigate("/credits", {
        state: {
          selectedPackage: packageInfo.package,
          packageKey: packageInfo.packageKey,
          guestCount: packageInfo.guestCount,
          fromPricing: true
        },
        replace: true,
      });
      return;
    }

    // Default case - user not from onboarding or pricing
    console.log("PhoneNumberLogin - Redirecting to my-invites (default case)");
    navigate("/my-invites");
  };

  return <LoginWhatsAppPage hideAlternate afterLogin={handleAfterLogin} />;
}
